import React,{Component} from 'react';

import './Services.css';

import { services1, services13, services14, services15, services2, services3, services4, services5, services6, services7, services8, services9 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { ImageBackgroundSlider } from '../../components/ImageBackgroundSlider/ImageBackgroundSlider';
import { get_page_title } from '../../utils/config';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
}

export default class Services extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state={
        }
    }
    render(){
        return (
        <Page 
            id="services"
            banner={{
                title: "services",
                bannerImage: services6,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`DAMPS - Services`) }</title>
                <meta 
                    name="description" 
                    content="Discover the services provided by DAMPS provided by the DAMPS platform"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    <h1 className="title-5">Objectives</h1>
                    <br/>

                    <h2 className="title-3">
                        Secure archiving & related activities focused on the data
                    </h2>
                    <div className="row-2 objective-activities">
                        <div className="objective-activities-description">
                            <ul>
                                <li>Data archival as well as related services of data ingestion, data extraction and data repatriation; </li>
                                <li>Data consolidation;</li>
                                <li>Data management and controlled evolution; </li>
                                <li>Data processing and elaboration as well as the related services of 
                                    integrating and orchestrating various processors. </li>
                            </ul>
                        </div>
                        <ImageBackgroundSlider
                            images={[
                                services1, services2, services3, services4, services8
                            ]} background_filter animated>
                        </ImageBackgroundSlider>
                    </div>
                    <br/>
                    <br/>
                    <h2 className="title-3">
                        Missions and corresponding data concerned
                    </h2>
                    
                    <div className="icons-with-text">
                        <div className="icon-with-text">
                            <i className="fas fa-satellite-dish"/>
                            <div className="text">
                                ESA Missions
                            </div>
                            <div className="sub-text">
                                ( ERS, ENVISAT, Earth Explorers )
                            </div>
                        </div>

                        <div className="icon-with-text">
                            <i className="fas fa-users"/>
                            <div className="text">
                                ESA Third Party Missions
                            </div>
                            <div className="sub-text">
                                ( e.g. Landsat, ALOS, etc. )
                            </div>
                        </div>

                        <div className="icon-with-text">
                            <i className="fas fa-calendar-alt"/>
                            <div className="text">
                                Historical, Present & Future missions
                            </div>
                            <div className="sub-text">
                                ( Future ESA missions are limited to Earth Explorers; Sentinels missions are not expected )
                            </div>
                        </div>
                        
                        <div className="icon-with-text">
                            <i className="fas fa-satellite"/>
                            <div className="text">
                                ESA Campaigns & Ad-hoc
                            </div>
                            <div className="sub-text">
                                {/* ESA Campaigns data and in general any ad-hoc dataset created for scientific purposes and published to the users  */}
                                ( ad-hoc dataset created for scientific purposes and published to the users )
                            </div>
                        </div>
                    </div>
                


                    
                </div>
                <br/>
                <div className="services">
                    <h1 className="title-5">Services</h1>
                    <br/>
                    <div className="services-service">

                        <div className="services-service-image" style={{
                            backgroundImage: `url(${services7})`
                        }}/>

                        <div className="services-service-description">
                            <h2 className="title-3">The Data Archival service</h2>
                            <p>
                                This service consists in providing a reliable archive of ESA’s Earth Observation data, covering historical, 
                                present and future ESA and Third Party missions:
                            </p>
                            <ul>
                                <li>
                                    Safely archiving of the data in two physical copies in physical sites remote from one another;
                                </li>
                                <li>
                                    Keeping and publishing an accurate account of the archive contents through the Data Management System;                                </li>
                                <li>
                                    Maintaining and executing the various archive operational procedures, including for the continuous alignment of the central 
                                    and redundancy copies of the data;
                                </li>
                                <li>
                                    Keeping the archival infrastructure in line with constructor recommendations, 
                                    including any updates and media migration;
                                </li>
                                <li>
                                    Producing reports on the status and contents of the archive.
                                </li>
                            </ul>
                        </div>
                            
                    </div>
                    <div className="services-service dark">

                        <div className="services-service-image contain" style={{
                            backgroundImage: `url(${services9})`
                        }}/>

                        <div className="services-service-description">
                            <h2 className="title-3">The Data bulk-extraction and delivery service</h2>
                            <p>
                                This Service consists in providing/delivering the data in scope of the Service together with 
                                accompanying metadata and mission documentation back to ESA (or other recipients) upon request.
                            </p>
                            <ul>
                                <li>
                                    Reception and acknowledgement of the request for data;
                                </li>
                                <li>
                                    Identification and extraction from the archive of the required data;
                                </li>
                                <li>
                                    Delivery of the data, on media or on-line;
                                </li>
                                <li>
                                    Verification of the data delivery activities;
                                </li>
                                <li>
                                    Logging of the delivery in the Data Management System;
                                </li>
                                <li>
                                    Monthly and upon request production of a data delivery report.
                                </li>
                            </ul>
                        </div>

                            
                    </div>

                    <div className="services-service">

                        <div className="services-service-image" style={{
                            backgroundImage: `url(${services5})`
                        }}/>

                        <div className="services-service-description">
                            <h2 className="title-3">
                                The Data Configuration Management, Change Management and Maintenance service
                            </h2>

                            <p>
                                This service groups the activities related to the management and movement of data but also covers data maintenance, 
                                data evolution and data alignment. It consists in: 
                            </p>
                            <ul>
                                <li>Collecting the meta-data and storing it in the Data Management System (DMS);</li>
                                <li>Identifying, managing, and exploiting the data information to use across DAMPS and other services; </li>
                                <li>Improving the data and corresponding documentation: The data is subject to maintenance under 
                                    formal change control, like any complex asset in operational use; </li>
                                <li>Checking for overlaps, verifying if reproductions are identical due to 
                                    possible replication of data (Data alignment); </li>
                                <li>Storing all the data evolution records in the DAMPS DMS (Data Management System). </li>
                            </ul>
                        </div>

                    </div>

                    <div className="services-service dark">

                        <div className="services-service-image" style={{
                            backgroundImage: `url(${services15})`
                        }}/>

                        <div className="services-service-description">
                            <h2 className="title-3">
                                The Data Information Service (DIS)
                            </h2>

                            <p>
                                This service collects, organises, stores and makes available data-related information 
                                from a variety of value-adding services, in and out of DAMPS, to provide a single 
                                information source on the data. It consists in:
                            </p>
                            <ul>
                                <li>
                                    Collecting meta-data about the EO data from various contributing systems and services; 
                                </li>
                                <li>
                                    Providing a single repository and user view of the comprehensive information regarding 
                                    the data under the management of the organisation; 
                                </li>
                                <li>
                                    Providing not only information regarding the data itself but also information on the value 
                                    added to the data by the various services (tracing of the provenance of the data).
                                </li>
                            </ul>
                        </div>


                    </div>

                    <div className="services-service">

                        <div className="services-service-image" style={{
                            backgroundImage: `url(${services14})`
                        }}/>

                        <div className="services-service-description">
                            <h2 className="title-3">
                                The Data consolidation 
                            </h2>
                            <p>
                                This service consists in producing a single dataset out of several input datasets to produce a Master 
                                dataset with maximum coverage, no duplications, no corruptions and a homogeneous format and naming convention.
                            </p>
                            <ul>
                                <li>Collection of the inputs and analysis of the available resources; </li>
                                <li>Consolidation in terms of completeness and coverage; </li>
                                <li>Production of statistics, completeness analysis and alignment with external repositories; </li>
                                <li>Performing verification of the data consolidation activities by another team. </li>
                            </ul>
                        </div>


                    </div>

                    <div className="services-service dark">

                        <div className="services-service-image" style={{
                            backgroundImage: `url(${services13})`
                        }}/>

                        <div className="services-service-description">
                            
                            <h2 className="title-3">
                                The Processing System Integration and Data processing  
                            </h2>
                            <p>
                                This service consists in executing reprocessing, bulk processing, and re-formatting operations on designated 
                                datasets in response to customer needs as well as the related services of integrating and orchestrating 
                                various processors, including:
                            </p>
                            <ul>
                                <li>Preparing the processing environment (Data & Infrastructure);</li>
                                <li>Installing and integrating the Processing System on the appropriate service-provided infrastructure;</li>
                                <li>Running the system on a selected set of data and based on a user-driven set of processing parameters;</li>
                                <li>Making output available to the processor owner for analysis;</li>
                                <li>Updating / tuning the processor, parameters and input data;</li>
                                <li>Iterating until the processor owner is satisfied with the outputs (Processor in “Operational Status”);</li>
                                <li>Executing and monitoring the operational processing of the required dataset;</li>
                                <li>Verifying the output data;</li>
                            </ul>
                        </div>

                    </div>

                </div>
            </div>
        </Page>
        );
    }

};
